<template>
<div class="industryEdition-page" v-if="isSmallScreen===false">
<headers :imageSrc="imageSrc"/>
<pc-mains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<bottom/>
</div>
<div class="industryEdition-page" v-else>
<headers :imageSrc="imageSrc"/>
<edit-mains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<edit-foot/>
</div>
</template>
<script>
import headers from '../../components/headers.vue'
import bottom from '@/components/bottom'
import EditMains from '../../components/editMains.vue'
import EditFoot from '../../components/editFoot.vue'
import PcMains from '../../components/pc-Mains.vue'
export default {
  components: { headers, bottom, EditMains, EditFoot, PcMains },
  data () {
    return {
      isSmallScreen: false,
      // 碳立方-企业零碳大脑-控排行业版
      // tlf_qyltdn_kphyb
      imageSrc: '../assets/image/tlf_qyltdn_kphyb.png',
      res1: '碳立方-企业零碳大脑-控排行业版本',
      res2: '利用物联网，比缘计算，区块链，大数据，云计算，AI等技术手段，实现企业碳盘查，为企业能源结构调整提供依据，根据生产计划和实际产能动态预测履约盈缺，自动匹配集团内各企业内部交',
      res3: '易，指定最优的履约计划和交易计划，实现碳资产交易信息化。',
      res4: '一：某国内头部水泥集团双碳管理平台项目  /  二：某上市水泥集团双碳资产管理平台项目',
      res5: '../assets/2023logoImage/tlf_qyltdn-kphybs.png'
    }
  },
  mounted () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.imageSrc = '../assets/image/kphybbanner.png'
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  },
  created () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.imageSrc = '../assets/image/kphybbanner.png'
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  }
}
</script>

<style scoped lang='scss'>

</style>
